module.exports = __webpack_public_path__ + "static/media/blender-phone.91ad5446.svg";